import React, { Component } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import RedirectFediverse from "../components/RedirectFediverse";

export default class RedirectMastodon extends Component {

  render() {
    return (
      <div className="content">
        <Header />
        <div className="mt-4"/>
        <RedirectFediverse type="Mastodon" msg="Retrieving your Mastodon followings. This may take a long depending on how many accounts you follow."/>
        <div className="mt-4"/>
        <Footer />
      </div>
      
    );
  }
}
